import { render, staticRenderFns } from "./CheckboxGroupElement.vue?vue&type=template&id=6f617e2c&scoped=true&"
import script from "./CheckboxGroupElement.vue?vue&type=script&lang=js&"
export * from "./CheckboxGroupElement.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxGroupElement.vue?vue&type=style&index=0&id=6f617e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f617e2c",
  null
  
)

export default component.exports